import { IResourceComponentsProps, useApiUrl, useModal, useNotification } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  DeleteButton,
  ShowButton,
  Icons,
  Button,
  Card,
  Form,
  Select,
  useSelect,
  Modal,
} from "@pankod/refine-antd";
import { BranchOffice, IBranchOfficesSearch, ILinkedPlaces } from "interfaces";
import { BFF_KEY } from "environment";
import { useState } from "react";
import { ModalBranchOfficeMunicipiesBind } from "components/modals";
import { ModalBranchOfficeMunicipiesBindMutiple } from "components/modals/mdl_branchoffice_municipies_multiple_bind";
import { axiosInstance } from "services/axios";

export const BranchMunicipalitiesList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter, tableQueryResult, searchFormProps } = useTable<ILinkedPlaces>({
    initialCurrent: 1,
    initialPageSize: 10,
    hasPagination: true,
    onSearch: (values: any) => {
      return [
        {
          field: "id_ob",
          operator: "eq",
          value: values.branch_id,
        }
      ];
    },
  });
  const [branchOffice, setBranchOffice] = useState<BranchOffice>();

  const { selectProps } = useSelect<IBranchOfficesSearch>({
    resource: "v1/branch-office/distinct-ids",
    optionLabel: "branch_id",
    optionValue: "branch_id",
    hasPagination: false
  });

  const apiUrl = useApiUrl();
  const toast = useNotification();

  const {
    show: branchOfficesBindShow,
    visible: branchOfficesBindVisible,
    close: branchOfficesBindClose,
  } = useModal();

  function showModal(branch: BranchOffice) {
    setBranchOffice(branch);
    branchOfficesBindShow();
  }

async function handleUnbindFilial(municipieId: number) {
  try {
    await axiosInstance.put(
      `${apiUrl}/v1/branch-office-place/${municipieId}/update-areaid/`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'ocp-apim-subscription-key': BFF_KEY
        },
      }
    );
    toast.open?.({
      message: 'Filial desvinculada do município com sucesso.',
      type: 'success',
    });
  } catch (error) {
    toast.open?.({
      message: 'ocorreu um erro ao tentar desvincular o município a filial selecionada, tente novamente mais tarde.',
      type: 'error',
    });
  } finally {
    tableQueryResult.refetch();
  }
}

  const {
    show: branchOfficesBindMutipleShow,
    visible: branchOfficesBindMutipleVisible,
    close: branchOfficesBindMutipleClose,
  } = useModal();

  return (
    <>
      <Card title="Busca">
      <div style={{ display: 'flex' }}>
        <Form {...searchFormProps} layout="inline">
          <Space>
            <Form.Item name="branch_id" label="Código da Filial:">
              <Select {...selectProps} style={{ width: "80px" }} />
            </Form.Item>
            <Button
              size="small"
              type="primary"
              icon={<Icons.SearchOutlined />}
              onClick={searchFormProps.form?.submit}
            >
              Buscar
            </Button>
          </Space>
        </Form>
        <Button style={{ marginLeft: 'auto' }} onClick={branchOfficesBindMutipleShow}>Vincular Multiplas Fillias</Button>
        </div>
      </Card>
      <List canCreate={true}>
        <Table {...tableProps} rowKey="HealthInsurerId">
          <Table.Column
            dataIndex="BranchOffice"
            key="BranchOffice"
            title="ID da Área"
            render={(value) => <TextField value={value.AreaId} />}
            defaultSortOrder={getDefaultSortOrder("BranchOffice.AreaId", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOffice"
            key="BranchOffice"
            title="Filial"
            render={(value) => <TextField value={value.AreaDescription} />}
            defaultSortOrder={getDefaultSortOrder("BranchOffice.AreaDescription", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOffice"
            key="BranchOffice"
            title="Estado da Filial"
            render={(value) => <TextField value={value?.Uf  ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOffice.Uf", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOfficePlace"
            key="BranchOfficePlace"
            title="Id"
            render={(value) => <TextField value={value?.Id  ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOfficePlace.PlaceDescription", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOfficePlace"
            key="BranchOfficePlace"
            title="Município"
            render={(value) => <TextField value={value?.PlaceDescription  ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOfficePlace.PlaceDescription", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOfficePlace"
            key="BranchOfficePlace"
            title="Estado do Município"
            render={(value) => <TextField value={value?.Uf  ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOfficePlace.Uf", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOfficePlace"
            key="BranchOfficePlace"
            title="Latitude"
            render={(value) => <TextField value={value?.Latitude  ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOfficePlace.Latitude", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="BranchOfficePlace"
            key="BranchOfficePlace"
            title="Longitude"
            render={(value) => <TextField value={value?.Longitude ?? 'nulo'} />}
            defaultSortOrder={getDefaultSortOrder("BranchOfficePlace.Longitude", sorter)}
            sorter
          />
          <Table.Column<ILinkedPlaces>
            title="Ações"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                { record.BranchOfficePlace ? <Button size="small" onClick={() => handleUnbindFilial(record.BranchOfficePlace.Id)}>Desvincular</Button> :  <Button size="small" onClick={() => showModal(record.BranchOffice)}>Vincular</Button>}
                <ShowButton hideText size="small" recordItemId={record.BranchOffice.AreaId} resourceNameOrRouteName="v1/branch-office"/>
                <DeleteButton hidden hideText size="small" recordItemId={record.BranchOffice.AreaId} />
              </Space>
            )}
          />
        </Table>
      </List>
      <Modal
        visible={branchOfficesBindVisible}
        onCancel={branchOfficesBindClose}
        destroyOnClose={true}
        width={840}
        title={"Vincular Município à Filial " + branchOffice?.AreaDescription}
        footer={null}
      >
        <ModalBranchOfficeMunicipiesBind 
          branchOffice={branchOffice} 
          closeModal={branchOfficesBindClose} 
          refreshTable={tableQueryResult.refetch}
        />
      </Modal>
      <Modal
        visible={branchOfficesBindMutipleVisible}
        onCancel={branchOfficesBindMutipleClose}
        destroyOnClose={true}
        width={960}
        title={"Vincular Mutiplas Filiais"}
        footer={null}
      >
        <ModalBranchOfficeMunicipiesBindMutiple
          closeModal={branchOfficesBindClose} 
          refreshTable={tableQueryResult.refetch}
        />
      </Modal>
    </>
  );
};
